module.exports = __webpack_public_path__ + "03_short_brown.c8783407.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/03_short_brown.png
// module id = HRs6
// module chunks = 0